import { useSearchParams } from 'react-router-dom';

const ERRORS: Record<string, string> = {
  oauth: 'Google sign-in was cancelled or failed.',
  state: 'Sign-in session expired. Please try again.',
  domain: 'Your account is not allowed. Use your @go.art Workspace account.',
  callback: 'Something went wrong completing sign-in.',
  no_id_token: 'Google did not return an identity token.',
  bad_token: 'Could not verify your Google identity.',
};

export function SignIn() {
  const [params] = useSearchParams();
  const error = params.get('error');

  return (
    <div className="signin">
      <div className="signin-card">
        <h1>Drive Viewer</h1>
        <p className="muted">Render and share HTML files from Google Drive.</p>
        {error && <p className="error">{ERRORS[error] ?? 'Sign-in failed.'}</p>}
        <a className="btn btn-primary" href="/auth/google">
          Sign in with Google
        </a>
        <p className="muted small">Restricted to @go.art Workspace accounts.</p>
      </div>
    </div>
  );
}
